import { cn } from "@/lib/utils";

/**
 * A hairline progress sliver for work of unknown duration.
 *
 * Reserves its height whether or not it is active, so switching a view or a
 * filter does not nudge the table down by a couple of pixels — the thing it is
 * reporting on is exactly the thing that must not appear to jump.
 */
export function IndeterminateBar({
  active,
  className,
  label = "Loading",
}: {
  active: boolean;
  className?: string;
  label?: string;
}) {
  return (
    <div
      className={cn("h-0.5 w-full overflow-hidden", className)}
      role={active ? "progressbar" : undefined}
      aria-label={active ? label : undefined}
      aria-busy={active}
    >
      {active && (
        <div className="h-full w-1/4 rounded-full bg-primary/70 animate-indeterminate motion-reduce:animate-none motion-reduce:w-full" />
      )}
    </div>
  );
}
